import { API_CONFIG } from '../constants';
import { apiFetch } from '../utils/apiFetch';
import type { PodData } from '../dtos/pod';
export type { PodData };
export const fetchPodData = async (ipAddress: string): Promise<PodData> => {
    try {
        const response = await apiFetch({
            url: API_CONFIG.ENDPOINTS.POD_IP(ipAddress),
            method: 'GET'
        });

        return await response.json();
    } catch (error) {
        console.error('Error fetching pod data:', error);
        throw error;
    }
};
